<template>
  <div class="home">
    <!-- <div class="full-screen-background"></div> -->
    <div class="centered-content">
      <h1 class="title">{{ t("find_any_fragrance") }}</h1>
      <div class="buttons">
        <router-link
          :to="{ name: RouteNames.ExploreByConcepts }"
          class="btn-container"
        >
          <ButtonWithFeedback class="btn btn--primary">
            <div class="button-title">{{ t("title_by_concepts") }}</div>
          </ButtonWithFeedback>
        </router-link>
        <router-link
          :to="{ name: RouteNames.ExploreByFamilies }"
          class="btn-container"
        >
          <ButtonWithFeedback class="btn btn--primary">
            <div class="button-title">{{ t("title_by_families") }}</div>
          </ButtonWithFeedback>
        </router-link>
      </div>
      <div class="logo"></div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ButtonWithFeedback from "@/components/ButtonWithFeedback";
import { RouteNames } from "../router";
export default {
  name: "home",
  metaInfo: {
    title: "Find your perfect fragrance - Reinvented",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "Wikiparfum is the encyclopedia for perfume lovers. A fragrance search engine based on olfactory preferences, that help users to visualize the perfume notes.",
      },
      {
        vmid: "og:title",
        name: "og:title",
        content: "Wikiparfum - Find your perfect fragrance - Reinvented",
      },
      {
        vmid: "og:description",
        name: "og:description",
        content:
          "Wikiparfum is the encyclopedia for perfume lovers. A fragrance search engine based on olfactory preferences, that help users to visualize the perfume notes.",
      },
      {
        vmid: "twitter:title",
        name: "twitter:title",
        content: "Wikiparfum - Find your perfect fragrance - Reinvented",
      },
      {
        vmid: "twitter:description",
        name: "twitter:description",
        content:
          "Wikiparfum is the encyclopedia for perfume lovers. A fragrance search engine based on olfactory preferences, that help users to visualize the perfume notes.",
      },
    ],
  },
  data() {
    return {
      RouteNames,
    };
  },
  components: {
    ButtonWithFeedback,
  },
  async mounted() {
    await this.eventTracker.emitEvent("NEW_SESSION");
    await this.eventTracker.emitEvent("VIEW_OPENED", { type: "LANDING_PAGE" });
    const isElectron = process.env.VUE_APP_ELECTRON === "true";
    if (isElectron) window.electron?.isUpdated();
  },
};
</script>

<style scoped lang='stylus'>
.home
  .centered-content
    align-items: center
    display: flex
    flex-direction: column
    justify-content: center
    left: 50%
    margin-top: vw(50px)
    padding: 0 5vw
    position: absolute
    top: 50%
    transform: translate(-50%, -50%)
    width: 100%

    .mobile &
      top: "calc(50% + %s)" % $header-height

    .title
      m-font-size(32, 50)
      font-weight: 500
      margin-bottom: vh(100px)
      text-align: center

      .mobile &
        m-font-size(36, 40)

    .buttons
      align-items: center
      display: flex
      gap: vw(40px)
      height: vw(150px)
      justify-content: center
      margin-bottom: vw(200px)

      .mobile &
        flex-direction: column
        height: auto

    .btn-container
      flex: 0 0 vw(400px)
      height: 100%
      max-width: vw(400px)
      width: vw(400px)

      .mobile &
        max-width: 100%
        width: 100%

        &:not(:last-child)
          margin-bottom: vh(20px)
          margin-right: 0

    .btn
      background-image: url("~@/assets/images/btn-bg.jpg")
      background-position: center center
      background-repeat: no-repeat
      background-size: cover
      flex-direction: column
      height: 100%
      padding: 2.5em 1.5em

      .mobile &
        padding: 1.5em 0.5em

      &:hover
        color: #fff

    .button-title
      m-font-size(28, 40)
      font-weight: 500

      .mobile &
        margin-bottom: 0
        margin-top: 0

    .logo
      background-image: url("~@/assets/images/logo.png")
      background-position: center center
      background-repeat: no-repeat
      background-size: cover
      height: vw(50px)
      width: vw(320px)
</style>
